import React, { useContext } from 'react';
import { array, string, oneOf } from 'prop-types';
import { useDispatch } from 'react-redux';
import classNames from 'classnames/bind';

import useStyles from 'hooks/useStyles';
import useGetCurrentDevice from 'hooks/useGetCurrentDevice';
import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import LessonListItem from 'routes/course/components/LessonListItem';
import CourseContext from 'routes/course/components/CourseContext';
import { getLessonEventTrackData } from 'routes/course/hooks/useLessonEventTrack';
import { COURSE_MATERIAL_CLICK } from 'constants/gtmEvent';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './CategoryLessons.scss';

const SIZE_LIST = ['small', 'large', 'full'];

const cx = classNames.bind(styles);

function CategoryLessons({ className, title, list, size }) {
  useStyles(styles);

  const dispatch = useDispatch();
  const { isPC } = useGetCurrentDevice();

  const {
    playerRef,
    currentLesson,
    onClickLesson,
    onClickLessonWrapper,
    courseEventTrackData,
  } = useContext(CourseContext);

  // eslint-disable-next-line no-shadow
  const handleMaterialClick = lesson => ({ id, title }) => {
    dispatch(
      sendGTMEvent({
        eventName: COURSE_MATERIAL_CLICK,
        data: {
          materialId: id,
          materialName: title,
          section: 'course_player_lessons_tab',
          ...courseEventTrackData,
          ...getLessonEventTrackData({
            lesson,
          }),
        },
      }),
    );
  };

  if (!list || list.length === 0) return null;

  return (
    <div className={cx(styles.root, className)}>
      {!!title && <h6 className={styles.title}>{title}</h6>}
      <div className={cx(styles.content, { [size]: isPC })}>
        <ul>
          {list.map((lesson, index) => {
            const isSelected = currentLesson.id === lesson.id;

            return (
              <LessonListItem
                {...lesson}
                key={lesson.id}
                playerRef={playerRef}
                isSelected={isSelected}
                isPlaying={isSelected && currentLesson.isPlaying}
                onLessonClick={() => onClickLesson(lesson, index)}
                onLessonWrapperClick={() => onClickLessonWrapper(lesson, index)}
                onMaterialClick={handleMaterialClick(lesson)}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
}

CategoryLessons.propTypes = {
  className: string,
  title: string,
  list: array.isRequired,
  size: oneOf(SIZE_LIST),
};

CategoryLessons.defaultProps = {
  className: '',
  title: '',
  size: SIZE_LIST[0],
};

export default CategoryLessons;
